export const FLOATING_TEXT_BG_COLOR = "rgba(20, 20, 20, 0.75)";
export const FLOATING_TEXT_BORDER_COLOR = "rgba(255, 255, 255, 0.2)";
export const FLOATING_TEXT_FONT_SIZE = 16;
export const FLOATING_TEXT_LINE_HEIGHT = 18;
export const FLOATING_TEXT_PADDING_X = 10;
export const FLOATING_TEXT_PADDING_Y = 8;
export const FLOATING_TEXT_BORDER_RADIUS = 5;
